module.exports = __webpack_public_path__ + "img/saude.f9b2c516.svg";